import React from "react";
import MyPortfolio from "./components/MyPortfolio";

function App() {
  return (
    <div className="App">
      <MyPortfolio />
    </div>
  );
}

export default App;
